import { render, staticRenderFns } from "./supplierGroup.vue?vue&type=template&id=5d403b6a&scoped=true"
import script from "./supplierGroup.vue?vue&type=script&lang=js"
export * from "./supplierGroup.vue?vue&type=script&lang=js"
import style0 from "./supplierGroup.vue?vue&type=style&index=0&id=5d403b6a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d403b6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d403b6a')) {
      api.createRecord('5d403b6a', component.options)
    } else {
      api.reload('5d403b6a', component.options)
    }
    module.hot.accept("./supplierGroup.vue?vue&type=template&id=5d403b6a&scoped=true", function () {
      api.rerender('5d403b6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/BCManage/supplierGroup.vue"
export default component.exports